import { render, staticRenderFns } from "./AddNewDropdownButton.vue?vue&type=template&id=61e5446d&scoped=true"
import script from "./AddNewDropdownButton.vue?vue&type=script&lang=js"
export * from "./AddNewDropdownButton.vue?vue&type=script&lang=js"
import style0 from "./AddNewDropdownButton.vue?vue&type=style&index=0&id=61e5446d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5446d",
  null
  
)

export default component.exports